export default {
    summary_text: 'Uw EcoCredits-overzicht',
    membership: 'LID',
    current_tier: 'Huidig niveau',
    points: 'EcoCredits',
    points_balance: 'EcoCredits-tegoed',
    points_progress_tips: 'EcoCredits die moeten worden behaald {plus}: {punten} EcoCredits',
    coming_soon: 'Binnenkort',
    redeem_now: 'NU INWISSELEN',
    points_activity: 'PUNTENACTIVITEIT',
    how_it_works: 'Hoe het werkt',
    already_member: 'Al lid?',
    already_member1: 'Al lid?',
    sign_up: 'Aanmelden',
    sign_up_desc: 'Maak een account aan en ontvang 500 EcoCredits als beloning.',
    sign_up_desc_h: '500 EcoCredits wanneer u lid wordt.',
    earn_points: 'VERDIEN EcoCredits',
    earn_points_desc: 'Verdien EcoCredits elke keer dat u winkelt.',
    redeem_points: 'WISSEL EcoCredits in',
    redeem_points_desc: 'Wissel EcoCredits in voor exclusieve kortingen.',
    earn_points_title: 'Methodes om Earn EcoCredits te verdienen',
    sign_up_text: '500 EcoCredits als u lid wordt',
    completed_text: 'U hebt deze beloning al behaald.',
    subscribe: 'Abonneren',
    subscribe_capital_letters: 'Abonneren',
    subscribe_text: 'Meld u aan voor de EcoFlow nieuwsbrief.',
    subscribe_hover: 'Verdien 500 EcoCredits wanneer u lid wordt.',
    subscribe_now: 'Nu abonneren',
    email_address: 'E-mailadres',
    shop: 'Winkelen',
    shop_capital_letters: 'Winkelen',
    earn_point_by_order: 'Verdien bij elke bestelling.',
    earn_point_rule_shop: 'Ontvang 1 EcoCredits voor elke € 1 die u besteedt.',
    shop_to_earn_points: 'Winkel om Earn EcoCredits te verdienen',
    warranty: 'Garantie',
    warranty_capital_letters: 'Garantie',
    warranty_desc1: '1000 EcoCredits wanneer u een product registreert.',
    warranty_desc2: '1000 EcoCredits wanneer u een product registreert.',
    profile: 'Profiel',
    profile_desc1: 'Verdien tot 1000 EcoCredits voor het invullen van uw profiel.',
    profile_desc2: 'Verdien tot 1000 EcoCredits voor het aanvullen van uw gegevens.',
    complete_profile: 'Profiel invullen',
    referral: 'Een vriend/vriendin uitgenodigd',
    referral_desc: 'Verdien EcoCredits voor elke vriend/vriendin die zich succesvol aanmeldt.',
    referral_btn: 'Word nu lid',
    redeem_ecocredits_title: 'Wissel EcoCredits-beloningen in',
    redeem_ecocredits_title_next: 'Nieuwe productbeloningen en kortingen zijn beschikbaar voor inwisseling.',
    member_exclusive: 'Exclusieve prijzen voor leden',
    redeem_ecocredits_subtitle_next: 'Meld u nu aan en bestel accessoires voor het balkonzonne-energiesysteem met 50% minder EcoCredits!',
    redeem_ecocredits_rules_title1: 'Voorstelling van het evenement:',
    redeem_ecocredits_rules_title2: 'Evenementenmechanisme:',
    redeem_ecocredits_rules_desc1:
        'Neem deel aan onze pop-up inwisselacties voor EcoCredits-beloningen tussen 20 oktober en 23 oktober 2023. Pop-ups verschijnen willekeurig op deze datums!',
    redeem_ecocredits_rules_desc2:
        '1. Ontgrendel verrassingen vroeg: Abonneer u en wees de eerste die de verrassingsstarttijden van de inwisselacties voor EcoCredits-beloningen te weten komt.',
    redeem_ecocredits_rules_desc3:
        '2. Maximaliseer uw EcoCredits: Profiteer tijdens elk pop-up evenement van een korting voor inwisselen van punten tot 50%. Maar handel snel! De hoeveelheid deelnemende producten is beperkt. Elke dag worden vier unieke producten in de promotie belicht, elk met maximaal 20 eenheden beschikbaar.',
    have_points: 'U hebt <code>{punten} EcoCredits</code>',
    view_all: 'Alle bekijken',
    coupon: 'Kortingscode',
    discount: 'Korting',
    gift_card: 'Cadeaubon',
    redeemed_succ: 'Inwisselen gelukt!',
    copy_desc: 'U hebt de code gekopieerd, ga naar de winkel om deze te gebruiken.',
    store: 'Shop nu',
    coupon_used_desc: 'Gebruik deze code bij het afrekenen om uw cadeaubon van {bedrag} in te wisselen.',

    rules: 'Regels',
    off: 'KORTING',
    site_rules: 'Alleen voor de winkel in Nederland.',
    days_rules: 'Geldig gedurende {days} dagen na het inwisselen.',
    product_rules: 'Alleen voor {product}.',
    days_rules2: 'Geldig vanaf {data}.',
    rewards_redeemed: 'Mijn beloningen',
    redeedmed_tab_name: 'Ingewisseld',
    issued_tab_name: 'Uitgegeven',
    available: 'Beschikbaar',
    redeemed: 'Ingewisseld',
    expired: 'Verlopen',
    edeemed_rewards_note: 'Uw ingewisselde beloningen verschijnen hier.',
    browse_ecocredits_rewards: 'EcoCredits-beloningen browsen',
    used: 'Gebruikt',
    give_away: 'Weggeven',
    or_text: 'OF',
    send_your_friend: 'Stuur uw {amont} cadeaubon naar een vriend/vriendin.',
    points_activity_a: 'Mijn activiteit',
    points_tab_name: 'EcoCredits-activiteit',
    rewards_tab_name: 'Beloningen-activiteit',
    date: 'Datum',
    action: 'Actie',
    rewards_title: 'Beloningen',
    question_title: 'Quiz spelen',
    type_title: 'Type',
    discount_type: 'Korting',
    purchase: 'Aankoop',
    profile_a: 'Profiel',
    refund: 'Terugbetaling',
    registered: 'Geregistreerd',
    points_capital_letters: 'EcoCredits',
    status: 'Status',
    pending: 'In afwachting',
    received: 'Ontvangen',
    deducted: 'In mindering gebracht',
    view_more: 'Meer bekijken',
    history_note: 'Uw EcoCredits-activiteit verschijnt hier. Ziet u uw EcoCredits nog niet? Uw activiteit wordt binnen 24 uur bijgewerkt.',
    lucky_flop_start: 'Word nu lid',
    lucky_flop_congrat: 'Gefeliciteerd',
    lucky_flop_get: 'Opeisen',
    lucky_flop_open: 'OPEN',
    ecoflow_benefits: 'EcoCredits-voordelen',
    membership_includes: 'HET LIDMAATSCHAP OMVAT',
    benefits_link_btn: 'Zie Algemene Voorwaarden',
    see_t_c: 'Zie Algemene Voorwaarden',
    manually_added: 'Handmatig toegevoegd',
    manually_deducted: 'Handmatig in mindering gebracht',
    faq_title: 'Veel-gestelde vragen',
    redeeming_points: 'EcoCredits WORDEN INGEWISSELD',
    network_error: 'Netwerkfout',
    confirm_text: 'Weet u zeker dat u wilt resetten? Dit kan niet ongedaan worden gemaakt.',
    confirm_btn: 'Bevestigen',
    no_enough_points: 'Inwisselen mislukt, uw EcoCredits zijn niet voldoende',
    no_history_note: 'Ziet u uw EcoCredits nog niet? Uw activiteit wordt binnen 24 uur bijgewerkt.',
    no_coupon_note: 'De beloningen zijn nog niet ingewisseld.',
    minimum_price: 'Minimum aankoopbedrag ({price}).',
    minimum_num: 'Minimale hoeveelheid artikelen({num} st.).',
    stay_too_long: 'Uw sessie is verlopen. Vernieuw de pagina en probeer het opnieuw.',
    order_rule: 'Slechts één kortingscode per bestelling.',
    purchas_rule: 'Als u een artikel koopt voor minder dan de waarde van de kortingsbon(nen), verliest u het verschil.',
    profile_birthday: 'Profiel - verjaardag',
    profile_address: 'Profiel - adres',
    profile_username: 'Profiel - gebruikersnaam',
    profile_picture: 'Profiel - foto',
    profile_contact: 'Profiel - contactinformatie',
    membership_faq_title: 'LIDMAATSCHAP',
    learn_more: 'Meer informatie',
    profile_detail:
        'Vul uw profiel in voor maximaal 1000 EcoCredits, inclusief profielfoto (200), gebruikersnaam (100), contactgegevens (300), adres (200) en geboortedatum (200).',
    exceeded_counts: 'Inwisselen mislukt. U hebt de inwisselingslimiet overschreden.',
    grab_title: 'Pak een EcoCredits-bonus',
    grab_sub_title: 'Exclusieve tijdelijke aanbiedingen voor EcoCredit-leden. Klik hier en eis het nu op!',
    grab_btn_text: 'Mijn Bonus pakken',
    grab_success_title: 'Gefeliciteerd',
    grab_success_text1: 'Bonus succesvol opgeëist!\n Plak de code bij het afrekenen om uw korting te krijgen.',
    grab_success_text2: 'Controleer uw bonussen <code>Mijn Beloningen</code>.',
    'no-grab-content-note': 'Er komen spoedig meer aanbiedingen!',
    copy_desc_2: 'U hebt de code gekopieerd.',
    city_validatino_error: 'Ongeldige stad',
    product_text: 'Product',
    shipping_address_text: 'Verzendadres',
    saved_address_text: 'Opgeslagen adressen',
    use_new_address: 'gebruik een nieuw adres',
    spend_now: 'Nu besteden',
    stock_left: '{stock} over',
    no_stock_tip: 'Binnenkort beschikbaar... Blijf op de hoogte!',
    order_text: 'Bestelling',
    campaign_time_limit_text: 'Geldige inwisselperiode: {startTime} - {endTime}.',
    event_action_text: 'Evenement',
    warranty_minus_action_text: 'Garantie verwijderd',
    question_correctly: 'Beantwoord de vraag correct',
    referral_correctly: 'Verwijzingsprogramma',
    confirm_btn_text: 'Sluiten',
    lucky_turntable_title: 'Gelukswiel',
    lucky_turntable_title2: 'Gelukswiel',
    join_lucky_with_points: 'Het kost u {points} EcoCredits om één ronde met het Gelukswiel te spelen.',
    join_lucky_with_points2: 'Het kost u {points} EcoCredits om een ronde te spelen.',
    join_lucky_desc: 'Draai aan het wiel en win een geweldige prijs!',
    remaining_number: '<code></code> draaiingen over',
    remaining_number2: '<code></code> omdraaiingen over',
    learn_lucky_rule: 'Meer informatie over de regels',
    prize_coupon_title: 'Gefeliciteerd',
    prize_coupon_sub_title: 'De prijs is succesvol opgeëist! Gebruik de code en spaar bij het afrekenen.',
    prize_coupon_action: 'Controleer uw prijzen in <code>Mijn Beloningen</code>.',
    prize_coupon_button: 'Shop nu',
    prize_points_title: 'Gefeliciteerd',
    prize_points_desc: 'Controleer de zojuist toegevoegde EcoCredits in <code>Mijn activiteit</code>.',
    limit_times_in_day: 'U kunt <count></count> keer per <day></day> dagen aan de wielen draaien',
    limit_times_in_day2: 'U kunt de kaarten <count></count> keer per <day></day> dagen omdraaien',
    limit_times_in_active: 'Tijdens het evenement kunt u tot <count></count> keer aan de wielen draaien.',
    limit_times_in_active2: 'Tijdens het evenement kunt u de kaarten tot <count></count> keer omdraaien.',
    without_limit_times: 'U kunt op elk moment <count></count> keer aan de wielen draaien.',
    without_limit_times2: 'U kunt op elk moment <count></count> keer de kaarten omdraaien.',
    active_is_unstart: 'Dit evenement komt er binnenkort aan.',
    active_is_ended: 'Dit evenement is beëindigd.',
    over_max_count: 'U hebt het beschikbaar aantal keren draaien overschreden.',
    notice_title: 'Opmerking',
    members_nav: 'Prijs voor leden',
    referral_nav: 'Verwijs een vriend',
    points_cash: 'Punten inwisselen',
    Pending1: 'In afwachting',
    rollback: 'Geretourneerd',
    product_hot_title: 'Meest verkochte producten',
    product_hot_desc: 'Mis het niet - koop nu voor exclusieve geschenken en onverslaanbare besparingen!',
    product_refurbished_title: 'Gereviseerde producten - Profiteer van betere aanbiedingen voor een beperkte tijd!',
    product_refurbished_desc: '17 okt 2024 09:00 (CEST) - 28 okt 2024 08:59 (CEST)',
    level_change_log: 'Niveau-activiteit',
    deadline: 'Geldig tot',
    history_refresh_member: 'Huidig niveau: Lid',
    history_refresh_plus_member: 'Huidig niveau: PLUS-lid',
    register: 'Registreren als lid',
    upgrade: 'Upgraden naar PLUS-lid',
    demotion: 'Downgraden naar lid',
    relegation: 'Aanhouden als PLUS-lid',
    ecocredits_notice1:
        'We hebben de EcoCredits-regels op 17 okt 2024 bijgewerkt. Lees aandachtig onze bijgewerkte [<line1>EcoCredits-regels</line1>] alvorens u uw EcoCredits gebruikt.',
    wattayear_2024: 'Deel#WattPerJaar',
    site_account_profile_save_success: 'Succes',
    not_eligible: 'U komt niet in aanmerking om aan dit evenement deel te nemen.',
};
